import { setSupportLegChoice } from 'ducks/sheets';
import { BehaviorParameters } from 'rangeConfig/@types';

export const forgetSupportLegsChoice = ({ dispatch }: BehaviorParameters) => {
  dispatch(setSupportLegChoice({ forgetChoice: true, productRef: undefined }));
};
